import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/business/containerOrder/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/business/containerOrder',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/business/containerOrder',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/business/containerOrder/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/business/containerOrder',
    method: 'get',
    params: {
      id
    }
  })
}

export function finish(id) {
  return request({
    url: '/api/business/containerOrder/finish',
    method: 'post',
    params: {
      id
    }
  })
}

export function saveCorrelation(data) {
  return request({
    url: '/api/business/containerOrder/saveCorrelation',
    method: 'post',
    data
  })
}
export function getCorrelationById(id) {
  return request({
    url: '/api/business/containerOrder/getCorrelationById',
    method: 'get',
    params: {
      id
    }
  })
}
export function getCopyCorrelationById(id) {
  return request({
    url: '/api/business/containerOrder/getCopyCorrelationById',
    method: 'get',
    params: {
      id
    }
  })
}
export function updateCorrelation(data) {
  return request({
    url: '/api/business/containerOrder/updateCorrelation',
    method: 'put',
    data
  })
}
export function getGroupProductName() {
  return request({
    url: '/api/business/containerOrder/getGroupProductName',
    method: 'get'
  })
}
export function recommendedShipper(params) {
  return request({
    url: '/api/business/containerOrder/recommended_shipper',
    method: 'get',
    params
  })
}

export function recommendedConsignee(params) {
  return request({
    url: '/api/business/containerOrder/recommended_consignee',
    method: 'get',
    params
  })
}

export function recommendedNotifyingParty(params) {
  return request({
    url: '/api/business/containerOrder/recommended_notifyingParty',
    method: 'get',
    params
  })
}
